
import { css } from 'lit';
export default css`
.container{
  border-left:2px solid var(--purple-indigo);
  padding-left:var(--spacing-4);
  font-family:var(--ff-body);
  font-size:var(--fs-body-mobile);
  font-weight:var(--fw-normal);
  line-height:var(--lh-body-mobile);
  color:var(--neutral-medium-gray);
}

@media (min-width: 768px){
  .container{
    padding-left:var(--spacing-6);
    font-size:var(--fs-body);
    line-height:var(--lh-body);
  }
}
`;